// Redux actions for User KPI Management

// Action Types
export const FETCH_USER_KPIS_REQUEST = 'userKpi/FETCH_USER_KPIS_REQUEST';
export const FETCH_USER_KPIS_SUCCESS = 'userKpi/FETCH_USER_KPIS_SUCCESS';
export const FETCH_USER_KPIS_FAILURE = 'userKpi/FETCH_USER_KPIS_FAILURE';

export const FETCH_USER_KPI_BY_ID_REQUEST = 'userKpi/FETCH_USER_KPI_BY_ID_REQUEST';
export const FETCH_USER_KPI_BY_ID_SUCCESS = 'userKpi/FETCH_USER_KPI_BY_ID_SUCCESS';
export const FETCH_USER_KPI_BY_ID_FAILURE = 'userKpi/FETCH_USER_KPI_BY_ID_FAILURE';

export const FETCH_USER_KPI_WITH_GOALS_REQUEST = 'userKpi/FETCH_USER_KPI_WITH_GOALS_REQUEST';
export const FETCH_USER_KPI_WITH_GOALS_SUCCESS = 'userKpi/FETCH_USER_KPI_WITH_GOALS_SUCCESS';
export const FETCH_USER_KPI_WITH_GOALS_FAILURE = 'userKpi/FETCH_USER_KPI_WITH_GOALS_FAILURE';

export const ASSIGN_USER_KPI_REQUEST = 'userKpi/ASSIGN_USER_KPI_REQUEST';
export const ASSIGN_USER_KPI_SUCCESS = 'userKpi/ASSIGN_USER_KPI_SUCCESS';
export const ASSIGN_USER_KPI_FAILURE = 'userKpi/ASSIGN_USER_KPI_FAILURE';

export const DELETE_USER_KPI_REQUEST = 'userKpi/DELETE_USER_KPI_REQUEST';
export const DELETE_USER_KPI_SUCCESS = 'userKpi/DELETE_USER_KPI_SUCCESS';
export const DELETE_USER_KPI_FAILURE = 'userKpi/DELETE_USER_KPI_FAILURE';

export const UPDATE_USER_KPI_REQUEST = 'userKpi/UPDATE_USER_KPI_REQUEST';
export const UPDATE_USER_KPI_SUCCESS = 'userKpi/UPDATE_USER_KPI_SUCCESS';
export const UPDATE_USER_KPI_FAILURE = 'userKpi/UPDATE_USER_KPI_FAILURE';

export const ADD_GOAL_TO_USER_KPI_REQUEST = 'userKpi/ADD_GOAL_TO_USER_KPI_REQUEST';
export const ADD_GOAL_TO_USER_KPI_SUCCESS = 'userKpi/ADD_GOAL_TO_USER_KPI_SUCCESS';
export const ADD_GOAL_TO_USER_KPI_FAILURE = 'userKpi/ADD_GOAL_TO_USER_KPI_FAILURE';

export const UPDATE_USER_KPI_GOAL_REQUEST = 'userKpi/UPDATE_USER_KPI_GOAL_REQUEST';
export const UPDATE_USER_KPI_GOAL_SUCCESS = 'userKpi/UPDATE_USER_KPI_GOAL_SUCCESS';
export const UPDATE_USER_KPI_GOAL_FAILURE = 'userKpi/UPDATE_USER_KPI_GOAL_FAILURE';

export const UPDATE_MULTIPLE_GOALS_REQUEST = 'userKpi/UPDATE_MULTIPLE_GOALS_REQUEST';
export const UPDATE_MULTIPLE_GOALS_SUCCESS = 'userKpi/UPDATE_MULTIPLE_GOALS_SUCCESS';
export const UPDATE_MULTIPLE_GOALS_FAILURE = 'userKpi/UPDATE_MULTIPLE_GOALS_FAILURE';

export const REMOVE_GOAL_FROM_USER_KPI_REQUEST = 'userKpi/REMOVE_GOAL_FROM_USER_KPI_REQUEST';
export const REMOVE_GOAL_FROM_USER_KPI_SUCCESS = 'userKpi/REMOVE_GOAL_FROM_USER_KPI_SUCCESS';
export const REMOVE_GOAL_FROM_USER_KPI_FAILURE = 'userKpi/REMOVE_GOAL_FROM_USER_KPI_FAILURE';

export const FETCH_USER_KPI_GOALS_REQUEST = 'userKpi/FETCH_USER_KPI_GOALS_REQUEST';
export const FETCH_USER_KPI_GOALS_SUCCESS = 'userKpi/FETCH_USER_KPI_GOALS_SUCCESS';
export const FETCH_USER_KPI_GOALS_FAILURE = 'userKpi/FETCH_USER_KPI_GOALS_FAILURE';

export const SET_USER_KPI_FILTERS = 'userKpi/SET_USER_KPI_FILTERS';
export const SET_USER_KPI_PAGINATION = 'userKpi/SET_USER_KPI_PAGINATION';
export const RESET_USER_KPI_FILTERS = 'userKpi/RESET_USER_KPI_FILTERS';

export const OPEN_USER_KPI_DIALOG = 'userKpi/OPEN_USER_KPI_DIALOG';
export const CLOSE_USER_KPI_DIALOG = 'userKpi/CLOSE_USER_KPI_DIALOG';

export const OPEN_MANAGE_GOALS_DIALOG = 'userKpi/OPEN_MANAGE_GOALS_DIALOG';
export const CLOSE_MANAGE_GOALS_DIALOG = 'userKpi/CLOSE_MANAGE_GOALS_DIALOG';

export const OPEN_DELETE_DIALOG = 'userKpi/OPEN_DELETE_DIALOG';
export const CLOSE_DELETE_DIALOG = 'userKpi/CLOSE_DELETE_DIALOG';

export const OPEN_EDIT_USER_KPI_DIALOG = 'userKpi/OPEN_EDIT_USER_KPI_DIALOG';
export const CLOSE_EDIT_USER_KPI_DIALOG = 'userKpi/CLOSE_EDIT_USER_KPI_DIALOG';

export const SET_SELECTED_USER_KPI = 'userKpi/SET_SELECTED_USER_KPI';
export const CLEAR_SELECTED_USER_KPI = 'userKpi/CLEAR_SELECTED_USER_KPI';

// Dropdown Data Actions
export const FETCH_ALL_USERS_REQUEST = 'userKpi/FETCH_ALL_USERS_REQUEST';
export const FETCH_ALL_USERS_SUCCESS = 'userKpi/FETCH_ALL_USERS_SUCCESS';
export const FETCH_ALL_USERS_FAILURE = 'userKpi/FETCH_ALL_USERS_FAILURE';

// Separate action for Edit Dialog using old preview endpoint
export const FETCH_USERS_FOR_EDIT_REQUEST = 'userKpi/FETCH_USERS_FOR_EDIT_REQUEST';
export const FETCH_USERS_FOR_EDIT_SUCCESS = 'userKpi/FETCH_USERS_FOR_EDIT_SUCCESS';
export const FETCH_USERS_FOR_EDIT_FAILURE = 'userKpi/FETCH_USERS_FOR_EDIT_FAILURE';

export const FETCH_ALL_PERIODS_REQUEST = 'userKpi/FETCH_ALL_PERIODS_REQUEST';
export const FETCH_ALL_PERIODS_SUCCESS = 'userKpi/FETCH_ALL_PERIODS_SUCCESS';
export const FETCH_ALL_PERIODS_FAILURE = 'userKpi/FETCH_ALL_PERIODS_FAILURE';

export const FETCH_ALL_TEMPLATES_REQUEST = 'userKpi/FETCH_ALL_TEMPLATES_REQUEST';
export const FETCH_ALL_TEMPLATES_SUCCESS = 'userKpi/FETCH_ALL_TEMPLATES_SUCCESS';
export const FETCH_ALL_TEMPLATES_FAILURE = 'userKpi/FETCH_ALL_TEMPLATES_FAILURE';

export const FETCH_ALL_GOALS_REQUEST = 'userKpi/FETCH_ALL_GOALS_REQUEST';
export const FETCH_ALL_GOALS_SUCCESS = 'userKpi/FETCH_ALL_GOALS_SUCCESS';
export const FETCH_ALL_GOALS_FAILURE = 'userKpi/FETCH_ALL_GOALS_FAILURE';

export const FETCH_ALL_DEPARTMENTS_REQUEST = 'userKpi/FETCH_ALL_DEPARTMENTS_REQUEST';
export const FETCH_ALL_DEPARTMENTS_SUCCESS = 'userKpi/FETCH_ALL_DEPARTMENTS_SUCCESS';
export const FETCH_ALL_DEPARTMENTS_FAILURE = 'userKpi/FETCH_ALL_DEPARTMENTS_FAILURE';

export const FETCH_ALL_DESIGNATIONS_REQUEST = 'userKpi/FETCH_ALL_DESIGNATIONS_REQUEST';
export const FETCH_ALL_DESIGNATIONS_SUCCESS = 'userKpi/FETCH_ALL_DESIGNATIONS_SUCCESS';
export const FETCH_ALL_DESIGNATIONS_FAILURE = 'userKpi/FETCH_ALL_DESIGNATIONS_FAILURE';

export const FETCH_ALL_REPORTING_MANAGERS_REQUEST = 'userKpi/FETCH_ALL_REPORTING_MANAGERS_REQUEST';
export const FETCH_ALL_REPORTING_MANAGERS_SUCCESS = 'userKpi/FETCH_ALL_REPORTING_MANAGERS_SUCCESS';
export const FETCH_ALL_REPORTING_MANAGERS_FAILURE = 'userKpi/FETCH_ALL_REPORTING_MANAGERS_FAILURE';

export const FETCH_DIRECT_LINE_MANAGERS_REQUEST = 'userKpi/FETCH_DIRECT_LINE_MANAGERS_REQUEST';
export const FETCH_DIRECT_LINE_MANAGERS_SUCCESS = 'userKpi/FETCH_DIRECT_LINE_MANAGERS_SUCCESS';
export const FETCH_DIRECT_LINE_MANAGERS_FAILURE = 'userKpi/FETCH_DIRECT_LINE_MANAGERS_FAILURE';

// Score Management Actions
export const FETCH_USER_KPI_SCORES_REQUEST = 'userKpi/FETCH_USER_KPI_SCORES_REQUEST';
export const FETCH_USER_KPI_SCORES_SUCCESS = 'userKpi/FETCH_USER_KPI_SCORES_SUCCESS';
export const FETCH_USER_KPI_SCORES_FAILURE = 'userKpi/FETCH_USER_KPI_SCORES_FAILURE';

export const CREATE_BULK_SCORES_REQUEST = 'userKpi/CREATE_BULK_SCORES_REQUEST';
export const CREATE_BULK_SCORES_SUCCESS = 'userKpi/CREATE_BULK_SCORES_SUCCESS';
export const CREATE_BULK_SCORES_FAILURE = 'userKpi/CREATE_BULK_SCORES_FAILURE';

export const CREATE_SCORE_REQUEST = 'userKpi/CREATE_SCORE_REQUEST';
export const CREATE_SCORE_SUCCESS = 'userKpi/CREATE_SCORE_SUCCESS';
export const CREATE_SCORE_FAILURE = 'userKpi/CREATE_SCORE_FAILURE';

export const UPDATE_SCORE_REQUEST = 'userKpi/UPDATE_SCORE_REQUEST';
export const UPDATE_SCORE_SUCCESS = 'userKpi/UPDATE_SCORE_SUCCESS';
export const UPDATE_SCORE_FAILURE = 'userKpi/UPDATE_SCORE_FAILURE';

export const DELETE_SCORE_REQUEST = 'userKpi/DELETE_SCORE_REQUEST';
export const DELETE_SCORE_SUCCESS = 'userKpi/DELETE_SCORE_SUCCESS';
export const DELETE_SCORE_FAILURE = 'userKpi/DELETE_SCORE_FAILURE';

export const OPEN_SCORE_DIALOG = 'userKpi/OPEN_SCORE_DIALOG';
export const CLOSE_SCORE_DIALOG = 'userKpi/CLOSE_SCORE_DIALOG';

// Action Creators
export const fetchUserKpisRequest = () => ({
    type: FETCH_USER_KPIS_REQUEST
});

export const fetchUserKpisSuccess = (data, pagination) => ({
    type: FETCH_USER_KPIS_SUCCESS,
    payload: { data, pagination }
});

export const fetchUserKpisFailure = (error) => ({
    type: FETCH_USER_KPIS_FAILURE,
    payload: error
});

export const fetchUserKpiByIdRequest = (id) => ({
    type: FETCH_USER_KPI_BY_ID_REQUEST,
    payload: id
});

export const fetchUserKpiByIdSuccess = (data) => ({
    type: FETCH_USER_KPI_BY_ID_SUCCESS,
    payload: data
});

export const fetchUserKpiByIdFailure = (error) => ({
    type: FETCH_USER_KPI_BY_ID_FAILURE,
    payload: error
});

export const fetchUserKpiWithGoalsRequest = (userId, periodId) => ({
    type: FETCH_USER_KPI_WITH_GOALS_REQUEST,
    payload: { userId, periodId }
});

export const fetchUserKpiWithGoalsSuccess = (data) => ({
    type: FETCH_USER_KPI_WITH_GOALS_SUCCESS,
    payload: data
});

export const fetchUserKpiWithGoalsFailure = (error) => ({
    type: FETCH_USER_KPI_WITH_GOALS_FAILURE,
    payload: error
});

export const assignUserKpiRequest = (data) => ({
    type: ASSIGN_USER_KPI_REQUEST,
    payload: data
});

export const assignUserKpiSuccess = (data) => ({
    type: ASSIGN_USER_KPI_SUCCESS,
    payload: data
});

export const assignUserKpiFailure = (error) => ({
    type: ASSIGN_USER_KPI_FAILURE,
    payload: error
});

export const deleteUserKpiRequest = (id) => ({
    type: DELETE_USER_KPI_REQUEST,
    payload: id
});

export const deleteUserKpiSuccess = (id) => ({
    type: DELETE_USER_KPI_SUCCESS,
    payload: id
});

export const deleteUserKpiFailure = (error) => ({
    type: DELETE_USER_KPI_FAILURE,
    payload: error
});

export const updateUserKpiRequest = (id, data) => ({
    type: UPDATE_USER_KPI_REQUEST,
    payload: { id, data }
});

export const updateUserKpiSuccess = (data) => ({
    type: UPDATE_USER_KPI_SUCCESS,
    payload: data
});

export const updateUserKpiFailure = (error) => ({
    type: UPDATE_USER_KPI_FAILURE,
    payload: error
});

export const addGoalToUserKpiRequest = (userKpiId, goalData) => ({
    type: ADD_GOAL_TO_USER_KPI_REQUEST,
    payload: { userKpiId, goalData }
});

export const addGoalToUserKpiSuccess = (data) => ({
    type: ADD_GOAL_TO_USER_KPI_SUCCESS,
    payload: data
});

export const addGoalToUserKpiFailure = (error) => ({
    type: ADD_GOAL_TO_USER_KPI_FAILURE,
    payload: error
});

export const updateUserKpiGoalRequest = (userKpiId, goalId, data) => ({
    type: UPDATE_USER_KPI_GOAL_REQUEST,
    payload: { userKpiId, goalId, data }
});

export const updateUserKpiGoalSuccess = (data) => ({
    type: UPDATE_USER_KPI_GOAL_SUCCESS,
    payload: data
});

export const updateUserKpiGoalFailure = (error) => ({
    type: UPDATE_USER_KPI_GOAL_FAILURE,
    payload: error
});

export const updateMultipleGoalsRequest = (userKpiId, goals) => ({
    type: UPDATE_MULTIPLE_GOALS_REQUEST,
    payload: { userKpiId, goals }
});

export const updateMultipleGoalsSuccess = (data) => ({
    type: UPDATE_MULTIPLE_GOALS_SUCCESS,
    payload: data
});

export const updateMultipleGoalsFailure = (error) => ({
    type: UPDATE_MULTIPLE_GOALS_FAILURE,
    payload: error
});

export const removeGoalFromUserKpiRequest = (userKpiId, goalId) => ({
    type: REMOVE_GOAL_FROM_USER_KPI_REQUEST,
    payload: { userKpiId, goalId }
});

export const removeGoalFromUserKpiSuccess = (goalId) => ({
    type: REMOVE_GOAL_FROM_USER_KPI_SUCCESS,
    payload: goalId
});

export const removeGoalFromUserKpiFailure = (error) => ({
    type: REMOVE_GOAL_FROM_USER_KPI_FAILURE,
    payload: error
});

export const fetchUserKpiGoalsRequest = (userKpiId) => ({
    type: FETCH_USER_KPI_GOALS_REQUEST,
    payload: userKpiId
});

export const fetchUserKpiGoalsSuccess = (data) => ({
    type: FETCH_USER_KPI_GOALS_SUCCESS,
    payload: data
});

export const fetchUserKpiGoalsFailure = (error) => ({
    type: FETCH_USER_KPI_GOALS_FAILURE,
    payload: error
});

export const setUserKpiFilters = (filters) => ({
    type: SET_USER_KPI_FILTERS,
    payload: filters
});

export const setUserKpiPagination = (pagination) => ({
    type: SET_USER_KPI_PAGINATION,
    payload: pagination
});

export const resetUserKpiFilters = () => ({
    type: RESET_USER_KPI_FILTERS
});

export const openUserKpiDialog = (userKpi = null) => ({
    type: OPEN_USER_KPI_DIALOG,
    payload: userKpi
});

export const closeUserKpiDialog = () => ({
    type: CLOSE_USER_KPI_DIALOG
});

export const openManageGoalsDialog = (userKpi) => ({
    type: OPEN_MANAGE_GOALS_DIALOG,
    payload: userKpi
});

export const closeManageGoalsDialog = () => ({
    type: CLOSE_MANAGE_GOALS_DIALOG
});

export const openDeleteDialog = (userKpi) => ({
    type: OPEN_DELETE_DIALOG,
    payload: userKpi
});

export const closeDeleteDialog = () => ({
    type: CLOSE_DELETE_DIALOG
});

export const openEditUserKpiDialog = (userKpi) => ({
    type: OPEN_EDIT_USER_KPI_DIALOG,
    payload: userKpi
});

export const closeEditUserKpiDialog = () => ({
    type: CLOSE_EDIT_USER_KPI_DIALOG
});

export const setSelectedUserKpi = (userKpi) => ({
    type: SET_SELECTED_USER_KPI,
    payload: userKpi
});

export const clearSelectedUserKpi = () => ({
    type: CLEAR_SELECTED_USER_KPI
});

// Dropdown Data Action Creators
export const fetchAllUsersRequest = () => ({
    type: FETCH_ALL_USERS_REQUEST
});

export const fetchAllUsersSuccess = (data) => ({
    type: FETCH_ALL_USERS_SUCCESS,
    payload: data
});

export const fetchAllUsersFailure = (error) => ({
    type: FETCH_ALL_USERS_FAILURE,
    payload: error
});

// Action Creators for Edit Dialog (using old preview endpoint)
export const fetchUsersForEditRequest = () => ({
    type: FETCH_USERS_FOR_EDIT_REQUEST
});

export const fetchUsersForEditSuccess = (data) => ({
    type: FETCH_USERS_FOR_EDIT_SUCCESS,
    payload: data
});

export const fetchUsersForEditFailure = (error) => ({
    type: FETCH_USERS_FOR_EDIT_FAILURE,
    payload: error
});

export const fetchAllPeriodsRequest = () => ({
    type: FETCH_ALL_PERIODS_REQUEST
});

export const fetchAllPeriodsSuccess = (data) => ({
    type: FETCH_ALL_PERIODS_SUCCESS,
    payload: data
});

export const fetchAllPeriodsFailure = (error) => ({
    type: FETCH_ALL_PERIODS_FAILURE,
    payload: error
});

export const fetchAllTemplatesRequest = () => ({
    type: FETCH_ALL_TEMPLATES_REQUEST
});

export const fetchAllTemplatesSuccess = (data) => ({
    type: FETCH_ALL_TEMPLATES_SUCCESS,
    payload: data
});

export const fetchAllTemplatesFailure = (error) => ({
    type: FETCH_ALL_TEMPLATES_FAILURE,
    payload: error
});

export const fetchAllGoalsRequest = () => ({
    type: FETCH_ALL_GOALS_REQUEST
});

export const fetchAllGoalsSuccess = (data) => ({
    type: FETCH_ALL_GOALS_SUCCESS,
    payload: data
});

export const fetchAllGoalsFailure = (error) => ({
    type: FETCH_ALL_GOALS_FAILURE,
    payload: error
});

export const fetchAllDepartmentsRequest = () => ({
    type: FETCH_ALL_DEPARTMENTS_REQUEST
});

export const fetchAllDepartmentsSuccess = (data) => ({
    type: FETCH_ALL_DEPARTMENTS_SUCCESS,
    payload: data
});

export const fetchAllDepartmentsFailure = (error) => ({
    type: FETCH_ALL_DEPARTMENTS_FAILURE,
    payload: error
});

export const fetchAllDesignationsRequest = () => ({
    type: FETCH_ALL_DESIGNATIONS_REQUEST
});

export const fetchAllDesignationsSuccess = (data) => ({
    type: FETCH_ALL_DESIGNATIONS_SUCCESS,
    payload: data
});

export const fetchAllDesignationsFailure = (error) => ({
    type: FETCH_ALL_DESIGNATIONS_FAILURE,
    payload: error
});

export const fetchAllReportingManagersRequest = () => ({
    type: FETCH_ALL_REPORTING_MANAGERS_REQUEST
});

export const fetchAllReportingManagersSuccess = (data) => ({
    type: FETCH_ALL_REPORTING_MANAGERS_SUCCESS,
    payload: data
});

export const fetchAllReportingManagersFailure = (error) => ({
    type: FETCH_ALL_REPORTING_MANAGERS_FAILURE,
    payload: error
});

export const fetchDirectLineManagersRequest = (managerEmail) => ({
    type: FETCH_DIRECT_LINE_MANAGERS_REQUEST,
    payload: managerEmail
});

export const fetchDirectLineManagersSuccess = (data) => ({
    type: FETCH_DIRECT_LINE_MANAGERS_SUCCESS,
    payload: data
});

export const fetchDirectLineManagersFailure = (error) => ({
    type: FETCH_DIRECT_LINE_MANAGERS_FAILURE,
    payload: error
});

// Score Management Action Creators
export const fetchUserKpiScoresRequest = (userKpiId) => ({
    type: FETCH_USER_KPI_SCORES_REQUEST,
    payload: userKpiId
});

export const fetchUserKpiScoresSuccess = (data) => ({
    type: FETCH_USER_KPI_SCORES_SUCCESS,
    payload: data
});

export const fetchUserKpiScoresFailure = (error) => ({
    type: FETCH_USER_KPI_SCORES_FAILURE,
    payload: error
});

export const createBulkScoresRequest = (scores) => ({
    type: CREATE_BULK_SCORES_REQUEST,
    payload: scores
});

export const createBulkScoresSuccess = (data) => ({
    type: CREATE_BULK_SCORES_SUCCESS,
    payload: data
});

export const createBulkScoresFailure = (error) => ({
    type: CREATE_BULK_SCORES_FAILURE,
    payload: error
});

export const createScoreRequest = (scoreData) => ({
    type: CREATE_SCORE_REQUEST,
    payload: scoreData
});

export const createScoreSuccess = (data) => ({
    type: CREATE_SCORE_SUCCESS,
    payload: data
});

export const createScoreFailure = (error) => ({
    type: CREATE_SCORE_FAILURE,
    payload: error
});

export const updateScoreRequest = (id, scoreData) => ({
    type: UPDATE_SCORE_REQUEST,
    payload: { id, scoreData }
});

export const updateScoreSuccess = (data) => ({
    type: UPDATE_SCORE_SUCCESS,
    payload: data
});

export const updateScoreFailure = (error) => ({
    type: UPDATE_SCORE_FAILURE,
    payload: error
});

export const deleteScoreRequest = (id) => ({
    type: DELETE_SCORE_REQUEST,
    payload: id
});

export const deleteScoreSuccess = (id) => ({
    type: DELETE_SCORE_SUCCESS,
    payload: id
});

export const deleteScoreFailure = (error) => ({
    type: DELETE_SCORE_FAILURE,
    payload: error
});

export const openScoreDialog = (userKpi) => ({
    type: OPEN_SCORE_DIALOG,
    payload: userKpi
});

export const closeScoreDialog = () => ({
    type: CLOSE_SCORE_DIALOG
});
